/**
 * Canonical widget theme catalog — shared so the admin Project Settings
 * "Appearance" picker and the in-widget Settings popover offer the SAME
 * themes, and a project's configured default validates against one list.
 *
 * Only the **ids + labels** live here. The actual CSS recipes (the
 * `--pl-*` token overrides for `corporate-blue`, `brutalist-warm`, …) ship
 * inside the widget bundle (`@pageloop/vanilla` → `internal/themes.ts`),
 * because they're styling, not contract. Adding a new theme = add it here
 * (id + label, so both pickers list it) AND add its recipe CSS in the
 * widget.
 */
/**
 * Theme ids a PROJECT can be configured to default to. `auto` follows the
 * visitor's OS; `light`/`dark` are the built-ins; the rest are bundled
 * recipes. The empty-string "use default" choice is a per-USER override
 * concept (clears the override), not a project value — so it's not here.
 */
export const PROJECT_THEME_IDS = [
    'auto',
    'light',
    'dark',
    'corporate-blue',
    'brutalist-warm',
    'brutalist-light',
    'minimal-neutral',
    'mocha-mornings',
];
/**
 * Display catalog (id + label) for theme pickers. Order is the display
 * order. The admin Appearance tab renders these as `<option>`s; the widget
 * settings popover prepends a "(project default)" entry then reuses these.
 */
export const THEME_OPTIONS = [
    { id: 'auto', label: 'Auto (follow visitor OS)' },
    { id: 'light', label: 'Light' },
    { id: 'dark', label: 'Dark' },
    { id: 'corporate-blue', label: 'Corporate Blue' },
    { id: 'brutalist-warm', label: 'Brutalist Warm' },
    { id: 'brutalist-light', label: 'Brutalist Light' },
    { id: 'minimal-neutral', label: 'Minimal Neutral' },
    { id: 'mocha-mornings', label: 'Mocha Mornings' },
];
/** Narrow an arbitrary string to a known {@link ProjectThemeId}. */
export function isProjectThemeId(v) {
    return typeof v === 'string' && PROJECT_THEME_IDS.includes(v);
}
//# sourceMappingURL=themes.js.map